export const ip = 'https://api.chinaecono.com/';
//export const ip = '/api/';
export const ip1 = 'https://sso.chinaecono.com/';
//export const ip1 = 'http://localhost:5140/';  
import Vue from 'vue'  
export default new Vue
//图标列表
export const iconAry=['ec-icon-fill','ec-icon-xiaofei','ec-icon-group-fill','ec-icon-user','ec-icon-lightning','ec-icon-relation',
'ec-icon-resource','ec-icon-theme','ec-icon-agro','ec-icon-edu','ec-icon-livelihood','ec-icon-industry','ec-icon-housing','ec-icon-finance',
'ec-icon-analysis','ec-icon-label','ec-icon-data','ec-icon-pie','ec-icon-text','ec-icon-organization','ec-icon-sport',
'ec-icon-fix','ec-icon-balance','ec-icon-send','ec-icon-ship','ec-icon-plane','ec-icon-stage','ec-icon-duibivs','ec-icon-xinwen',
'ec-icon-list','ec-icon-ep','ec-icon-fenxi','ec-icon-xinwen','ec-icon-setting-fill','ec-icon-s-user','ec-icon-lock','ec-icon-follow-fill'];
//自动生成报告，配置项的各项类型
export const regionTypeList=[{id:1,name:'单地区'},{id:2,name:'多地区'},{id:3,name:'同级地区'},{id:4,name:'下级地区'}];
export const itemTypeList=[{id:1,name:'单指标'},{id:2,name:'多指标'}];
export const dateTypeList=[{id:1,name:'时间点'},{id:2,name:'时间段'}];
export const orderTypeList=[{id:0,name:'无排序'},{id:1,name:'正序'},{id:2,name:'倒序'}];
export const displayTypeList=[{id:2,name:'表格'},{id:3,name:'折线图'},{id:4,name:'柱状图'},{id:5,name:'条状图'},{id:6,name:'饼图'},{id:7,name:'面积图'},{id:8,name:'雷达图'}];
//微信小程序数据分析
//访问时长
export const accessStaytime=[{id:1,name:'0-2s'},{id:2,name:'6-10s'},{id:3,name:'11-20s'},{id:4,name:'11-20s'},{id:5,name:'20-30s'},{id:6,name:'30-50s'},{id:7,name:'50-100s'},{id:8,name:'>100s'}]
//访问深度
export const accessDepth=[{id:1,name:'1页'},{id:2,name:'2页'},{id:3,name:'3页'},{id:4,name:'4页'},{id:5,name:'5页'},{id:6,name:'6-10页'},{id:7,name:'>10页'}]
//访问来源
export const accessSource=[{id:1,name:'小程序历史列表'},{id:2,name:'搜索'},{id:3,name:'会话'},{id:4,name:'扫一扫二维码'},{id:5,name:'公众号主页'},{id:6,name:'聊天顶部'},{id:7,name:'系统桌面'},
{id:8,name:'小程序主页'},{id:9,name:'附近的小程序'},{id:11,name:'模板消息'},{id:12,name:'客服消息'},{id:13,name:'公众号菜单'},{id:14,name:'APP分享'},{id:15,name:'支付完成页'},
{id:16,name:'长按识别二维码'},{id:17,name:'相册选取二维码'},{id:18,name:'公众号文章'},{id:19,name:'钱包'},{id:20,name:'卡包'},{id:21,name:'小程序内卡券'},{id:22,name:'其他小程序'},
{id:23,name:'其他小程序返回'},{id:24,name:'卡券适用门店列表'},{id:25,name:'搜索框快捷入口'},{id:26,name:'小程序客服消息'},{id:27,name:'公众号下发'},{id:28,name:'系统会话菜单'},{id:29,name:'任务栏-最近使用'},
{id:30,name:'长按小程序菜单圆点'},{id:31,name:'连wifi成功页'},{id:32,name:'城市服务'},{id:33,name:'微信广告'},{id:34,name:'其他移动应用'},{id:35,name:'发现入口-我的小程序'},{id:36,name:'任务栏-我的小程序'},
{id:37,name:'微信圈子'},{id:38,name:'手机充值'},{id:39,name:'H5'},{id:40,name:'插件'},{id:41,name:'大家在用'},{id:42,name:'发现页'},{id:43,name:'浮窗'},
{id:44,name:'附近的人'},{id:45,name:'看一看'},{id:46,name:'朋友圈'},{id:47,name:'企业微信'},{id:48,name:'视频'},{id:49,name:'收藏'},{id:50,name:'微信红包'},
{id:51,name:'微信游戏中心'},{id:52,name:'摇一摇'},{id:53,name:'公众号导购消息'},{id:54,name:'识物'},{id:55,name:'小程序订单'},{id:56,name:'小程序直播'},{id:57,name:'群工具'},{id:10,name:'其他'}]
//指标数据的开始日期
export const startDate='2005-01-01';
export const treeFind =function (tree,func) {
  for (const data of tree) {
    if (func(data)) return data
    if (data.children) {
      const res = treeFind(data.children, func)
      if (res) return res
    }
  }
  return null
}

export const treeFilter=function (tree, func) {
  // 使用map复制一下节点，避免修改到原树
  return tree.map(node => ({ ...node })).filter(node => {
    node.children = node.children && treeFilter(node.children, func)
    return func(node) || (node.children && node.children.length)
  })
}
export const sha1 =  function(s) {
  var data = new Uint8Array(encodeUTF8(s))
  var i, j, t;
  var l = ((data.length + 8) >>> 6 << 4) + 16, s = new Uint8Array(l << 2);
  s.set(new Uint8Array(data.buffer)), s = new Uint32Array(s.buffer);
  for (t = new DataView(s.buffer), i = 0; i < l; i++)s[i] = t.getUint32(i << 2);
  s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
  s[l - 1] = data.length << 3;
  var w = [], f = [
      function () { return m[1] & m[2] | ~m[1] & m[3]; },
      function () { return m[1] ^ m[2] ^ m[3]; },
      function () { return m[1] & m[2] | m[1] & m[3] | m[2] & m[3]; },
      function () { return m[1] ^ m[2] ^ m[3]; }
    ], rol = function (n, c) { return n << c | n >>> (32 - c); },
    k = [1518500249, 1859775393, -1894007588, -899497514],
    m = [1732584193, -271733879, null, null, -1009589776];
  m[2] = ~m[0], m[3] = ~m[1];
  for (i = 0; i < s.length; i += 16) {
    var o = m.slice(0);
    for (j = 0; j < 80; j++)
      w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1),
        t = rol(m[0], 5) + f[j / 20 | 0]() + m[4] + w[j] + k[j / 20 | 0] | 0,
        m[1] = rol(m[1], 30), m.pop(), m.unshift(t);
    for (j = 0; j < 5; j++)m[j] = m[j] + o[j] | 0;
  };
  t = new DataView(new Uint32Array(m).buffer);
  for (var i = 0; i < 5; i++)m[i] = t.getUint32(i << 2);
  var hex = Array.prototype.map.call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
    return (e < 16 ? "0" : "") + e.toString(16);
  }).join("");
  return hex;
}
/**
 * 日期格式化函数
 * @param date 日期对象
 * @param format 日期格式，默认为 YYYY-MM-DD HH:mm:ss
 */
export const formatDate=function(date, format = 'YYYY-MM-DD HH:mm:ss'){
  // 获取年月日时分秒，通过 padStart 补 0
  const d = new Date(date)
  const year = String(d.getFullYear())
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')

  // 返回格式化后的结果
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}
/**
 * 根据prop属性对数组进行排序
 * @param {*} arr 
 * @param {*} prop 
 * @param {*} order 
 * @returns 
 */

export const sortByProperty=(arr, prop, order = 'asc')=> {
  return arr.slice().sort((a, b) => {
    const valA = a[prop];
    const valB = b[prop];
    
    if (typeof valA === 'number' && typeof valB === 'number') {
      return order === 'asc' ? valA - valB : valB - valA;
    } else {
      return order === 'asc' 
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    }
  });
}
/**
 * 获取数组中prop属性=value的数量
 * @param {*} arr 
 * @param {*} prop 
 * @param {*} value 
 * @returns 
 */
export const fastCount=(arr, prop, value)=> {
  return arr.reduce((count, item) => 
    item[prop] === value ? count + 1 : count, 0
  );
}
/**
 * 在地区列表中根据value值查找对应的name
 * @param {Array} regionList - 地区列表（三级递归结构）
 * @param {string|number} value - 要查找的value值
 * @returns {string|null} - 返回对应的name，如果找不到则返回null
 */
export const findRegionName=(regionList, value)=> {
  for (const region of regionList) {
      // 检查当前层级的region是否匹配
      if (region.value == value) {
        return region.label;
      }
      // 如果有子级，递归查找子级
      if (region.children && region.children.length > 0) {
        const result = findRegionName(region.children, value);
        if (result) {
          return result;
        }
      }
  }
  // 如果遍历完所有可能性还没找到，返回null
  return null;
}
/**
 * 在多级分类中查找指定值的完整路径名称
 * @param {Array} classList 分类列表
 * @param {String|Number} value 要查找的值
 * @param {String} [childrenKey='children'] 子级列表的属性名
 * @param {String} [nameKey='name'] 名称属性名
 * @param {String} [valueKey='value'] 值属性名
 * @returns {String} 匹配的完整路径名称，如"一级,二级,三级"
 */
export const findClassPath = (classList, value, childrenKey = 'children', nameKey = 'name', valueKey = 'value') => {
  if (!classList || !value) return '';
  // 递归查找函数
  const findPath = (list, targetValue, path = []) => {
    for (const item of list) {
      // 当前节点匹配
      if (item[valueKey] === targetValue) {
        return [...path, item[nameKey]].join(',');
      }
      
      // 检查子节点
      if (item[childrenKey] && item[childrenKey].length) {
        const found = findPath(item[childrenKey], targetValue, [...path, item[nameKey]]);
        if (found) return found;
      }
    }
    return '';
  };
  return findPath(classList, value);
};
/**
 * 获取当前登录的浏览器
 */
export function getBrowserInfo(){
  var agent = navigator.userAgent.toLowerCase() ;
  console.log("agent:", agent);
  var arr = [];
  var system = agent.split(' ')[1].split(' ')[0].split('(')[1];
  arr.push(system);
  var regStr_edge = /edge\/[\d.]+/gi;
  var regStr_ie = /trident\/[\d.]+/gi ;
  var regStr_ff = /firefox\/[\d.]+/gi;
  var regStr_chrome = /chrome\/[\d.]+/gi ;
  var regStr_saf = /safari\/[\d.]+/gi ;
  var regStr_opera = /opr\/[\d.]+/gi;
  //IE
  if(agent.indexOf("trident") > 0){
    arr.push(agent.match(regStr_ie)[0].split('/')[0]);
    arr.push(agent.match(regStr_ie)[0].split('/')[1]);
    return arr;
  }
  //Edge
  if(agent.indexOf('edge') > 0){
    arr.push(agent.match(regStr_edge)[0].split('/')[0]);
    arr.push(agent.match(regStr_edge)[0].split('/')[1]);
    return arr;
  }
  //firefox
  if(agent.indexOf("firefox") > 0){
    arr.push(agent.match(regStr_ff)[0].split('/')[0]);
    arr.push(agent.match(regStr_ff)[0].split('/')[1]);
    return arr;
  }
  //Opera
  if(agent.indexOf("opr")>0){
    arr.push(agent.match(regStr_opera)[0].split('/')[0]);
    arr.push(agent.match(regStr_opera)[0].split('/')[1]);
    return arr;
  }
  //Safari
  if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0){
    arr.push(agent.match(regStr_saf)[0].split('/')[0]);
    arr.push(agent.match(regStr_saf)[0].split('/')[1]);
    return arr;
  }
  //Chrome
  if(agent.indexOf("chrome") > 0){
    arr.push(agent.match(regStr_chrome)[0].split('/')[0]);
    arr.push(agent.match(regStr_chrome)[0].split('/')[1]);
    return arr;
  }
  // else{
  //   arr.push('请更换主流浏览器,例如chrome,firefox,opera,safari,IE,Edge!')
  //   return arr;
  // }
}




// WEBPACK FOOTER //
// ./src/assets/js/public.js